import { useEffect, Dispatch, SetStateAction } from 'react';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, DotGroup } from 'pure-react-carousel';
import 'pure-react-carousel/dist/react-carousel.es.css';
import './Carousel.css';
import ImageCard from './image/ImageCard';
import {
  Modal,
  ModalConfig,
  ModalPositionX,
  ModalPositionY,
  ModalContent
} from '../../shared/modal/Modal';
import Loading from '../loading/Loading';

const ImageModalConfig: ModalConfig = {
  title: "Property Images",
  showHeader: true,
  positionX: ModalPositionX.center,
  positionY: ModalPositionY.center,
  showOverlay: true
};

interface CarouselProps {
  imageUrl: string[];
  showImageModal: boolean;
  setShowImageModal: Dispatch<SetStateAction<boolean>>;
}

export default function Carousel({ imageUrl, showImageModal, setShowImageModal }: CarouselProps) {

  useEffect(() => {
    const slider = document.getElementById('geoconnect-property--carousel');
    slider?.focus();
  }, []);

  return (
    <Modal
      show={showImageModal}
      setShow={setShowImageModal}
      resetPdfSrc={() => {}}
      config={ImageModalConfig}
    >
      <ModalContent>
        <CarouselProvider
          visibleSlides={1}
          totalSlides={imageUrl.length}
          step={1}
          naturalSlideHeight={500}
          naturalSlideWidth={400}
          isIntrinsicHeight={true}
          hasMasterSpinner={true}
          infinite={true}
        >
          <div className="carousel-slider-wrapper">
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Slider id="geoconnect-property--carousel" spinner={() => <Spinner />}>
                {imageUrl.map((url, index: number) => (
                  <Slide key={`carousel--property-image-${index + 1}`} index={index}>
                    <ImageCard url={url} />
                  </Slide>
                ))}
              </Slider>
            </div>
            <div className="carousel-controls">
              <ButtonBack className='carousel-controls--button'>
                <span className='esri-icon-left'></span>
              </ButtonBack>
              <DotGroup className='dot-group' />
              <ButtonNext className='carousel-controls--button'><span className='esri-icon-right'></span></ButtonNext>
            </div>
          </div>
        </CarouselProvider>
      </ModalContent>
    </Modal>
  )
}

const Spinner = () => (
  <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
    <Loading />
  </div>
);